import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';

const getAudienceSlug = (t, option) => {
  switch (option) {
    case 'internal':
      return t('internalEmployees');
    case 'external':
      return t('externalEmployees');
    default:
      return option;
  }
};

const PublishFeedOptionsChip = ({ value }) => {
  const { t } = useContext(ConfigContext);

  if (Array.isArray(value)) {
    return <>{value.map((option) => getAudienceSlug(t, option)).join(', ')}</>;
  }

  return <>{getAudienceSlug(t, value)}</>;
};

export default PublishFeedOptionsChip;
